import React from 'react';
import { LegacyWrappedCardContainer } from './legacy-wrapped-card-container.js';
import { LegacyNarrowHorizontalContainer } from './legacy-narrow-horizontal-container.js';
import { LegacyDefaultCardContainer } from './legacy-default-card-container.js';

var LegacyCardContainer = function LegacyCardContainer(_ref) {
  var cardProps = _ref.cardProps,
      cardEffects = _ref.cardEffects;
  var isWrapper = cardProps.isWrapper;
  var isNarrowHorizontal = cardEffects.isNarrowHorizontal;
  cardEffects.mediaRight;

  if (isWrapper) {
    return /*#__PURE__*/React.createElement(LegacyWrappedCardContainer, {
      cardProps: cardProps,
      cardEffects: cardEffects
    });
  } else if (isNarrowHorizontal) {
    return /*#__PURE__*/React.createElement(LegacyNarrowHorizontalContainer, {
      cardProps: cardProps,
      cardEffects: cardEffects
    });
  }

  return /*#__PURE__*/React.createElement(LegacyDefaultCardContainer, {
    cardProps: cardProps,
    cardEffects: cardEffects
  });
};

LegacyCardContainer.displayName = "LegacyCardContainer";
export { LegacyCardContainer };